import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router/index';
import CookieBanner from './components/feature/CookieBanner';


function App() {

  return (
    <BrowserRouter>
      <AppRoutes />
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;